import { PatternFormat } from "react-number-format";

function CnicText({ text, ...rest }: any) {
  return (
    <PatternFormat
      displayType="text"
      format="#####-*******-#"
      value={text}
      valueIsNumericString
      {...rest}
    />
  );
}

export default CnicText;
